import { http, HttpResponse } from 'msw';
import { env } from '@repo/env';
import { apiPaths } from '@repo/api/client';
import { loanOfferResponseMock } from './mocks/loan-offer.mock';
// import { loanOfferNoOffersResponseMock } from './mocks/loan-offer.mock';
var apiUrl = env.VITE_API_URL;
export var loanOfferHandler = [
    http.post("".concat(apiUrl).concat(apiPaths.loan.offer.path), function () {
        return HttpResponse.json(loanOfferResponseMock);
    }),
    // http.post(`${apiUrl}${apiPaths.loan.offer.path}`, () => {
    //   return HttpResponse.json(loanOfferNoOffersResponseMock);
    // }),
];
